module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_hearts-9.e436b265.svg";